import React, { useContext, useEffect} from 'react';
import { useClient } from '../../../../hooks/useClient'
import cl from './ClientList.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import AddClientModal from '../ClientAdd/ClientAdd'; 
import tbl from '../../../../assets/Style/Table.module.css'
import ClientDelete from '../ClientDelete/ClientDelete';
import ClientEdit from '../ClientEdit/ClientEdit';

const ClientList = () => {
  const { clientService } = useClient(20);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
        clientService.fetchList()
    }, [])
 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        clientService.setFilter({
        ...clientService.filter,
        [name]: value
        });
    };
     
  return <div>

    <div className={ cl.headMain }> 
        <h1>კლიენტები</h1>   
        <AddClientModal clientService={clientService} /> 
    </div>

    <div className={tbl.table + ' ' + cl.table}>

        <table>
            <thead>
                <tr>
                <th className={cl.id} >#</th>
                <th className={ cl.pad0 }>
                    <input name="firstname"  placeholder="სახელი გვარი" value={clientService.filter.firstname} onChange={handleInputChange} /> 
                </th>
                <th className={ cl.pad0 }>
                    <input name="email" placeholder="ელ-ფოსტა" value={clientService.filter.email}  onChange={handleInputChange} />
                </th>
                <th className={ cl.pad0 }>
                    <input  name="mobile" placeholder="მობილური" value={clientService.filter.mobile} onChange={handleInputChange} />
                </th>
                <th className={ cl.pad0 }>
                    <input name="personal" placeholder="პურადი ნომერი" value={clientService.filter.personal}  onChange={handleInputChange} />
                </th>
                <th> </th> 
                </tr>
            </thead>
            <tbody>
                {clientService.items.map((client) =>
                    <tr key={client.id} >
                    <td className={cl.id} >{client.id} </td>
                    <td>{client.firstname}  {client.lastname}</td>
                    <td>{client.email}</td>
                    <td>{client.mobile}</td>
                    <td>{client.personal}</td>
                    <td className={ cl.btntbl }>
                        <div className={ cl.btns }>
                            <ClientEdit clientService={clientService} defaultClient={client}/>
                            <ClientDelete clientService={clientService} defaultClient={client}/>
                        </div>
                    </td>
                    </tr>  
                )}
            </tbody>
        </table>

    </div>
 
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination 
        total={clientService.total} 
        perPage={clientService.filter.limit} 
        current={clientService.filter.page} 
        paginate={(page) => {
            clientService.setFilter({
            ...clientService.filter,
            page: page,
            });
        }}
        setLimit={(limit) => {
            clientService.setFilter({
            ...clientService.filter,
            limit: limit,
            });
        }}
    />
  </div>;
}

export default ClientList;